import React, { Component } from 'react';
import moment from 'moment';
import { Form, Input, Modal, Select, DatePicker, Button, message } from "antd";
import { getTypicalCasesBaseInfo, initHospitalDepts, initDeptDoctor, getNewReferral, getOtherSettingReferralInfo } from '@/request/api'
import { handleEnglishName, handleChangeAgeUnit, changeAge, onChangeBirthday,requestErrorLog } from '@/common/util'

const { Option } = Select;
const { TextArea } = Input;

class ReferralPatient extends Component {
      state = {
            departmentList: [],     //申请科室
            doctorList: [],         //申请医生
            deptCode: '',           //申请科室cdoe
            deptName: '',           //申请科室name
            doctorCode: '',         //申请医生code
            doctorName: '',          //申请医生name
      }

      componentDidMount() {
            this.allBasicData()
            this.initHospitalDept()
            this.getMustInputList()
            const rowData = this.props.rowData || {};
            console.log(rowData, 'rowData');
            if (rowData.REQ_DEPT_CODE) {
                  this.initDoctor(rowData.REQ_DEPT_CODE)
                  this.setState({
                        deptCode: rowData.REQ_DEPT_CODE,
                        deptName: rowData.REQ_DEPT_NAME,
                        doctorCode: rowData.REQ_DOCTOR_CODE,
                        doctorName: rowData.REQ_DOCTOR_NAME,
                  })
            }
      }

      getMustInputList = () => {
            getOtherSettingReferralInfo().then((res) => {
                  if (res && res.Status === 1) {
                        const checkInfo = res.Result
                        let NAME_PHONETIC = checkInfo.find(item => item.REQUIRED_NAME.trim() === '英文姓名') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '英文姓名').ISREQUIRED : false;
                        let HEIGHT = checkInfo.find(item => item.REQUIRED_NAME.trim() === '身高') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '身高').ISREQUIRED : false;
                        let EXAM_AGE = checkInfo.find(item => item.REQUIRED_NAME.trim() === '年龄') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '年龄').ISREQUIRED : false;
                        let WEIGHT = checkInfo.find(item => item.REQUIRED_NAME.trim() === '体重') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '体重').ISREQUIRED : false;
                        let NATIVE_PLACE = checkInfo.find(item => item.REQUIRED_NAME.trim() === '籍贯') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '籍贯').ISREQUIRED : false;
                        let ZIP_CODE = checkInfo.find(item => item.REQUIRED_NAME.trim() === '邮编') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '邮编').ISREQUIRED : false;
                        let CONTACT_TEL = checkInfo.find(item => item.REQUIRED_NAME.trim() === '手机号') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '手机号').ISREQUIRED : false;
                        let ID_NUMBER = checkInfo.find(item => item.REQUIRED_NAME.trim() === '身份证号') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '身份证号').ISREQUIRED : false;
                        let MAILING_ADDRESS = checkInfo.find(item => item.REQUIRED_NAME.trim() === '通讯地址') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '通讯地址').ISREQUIRED : false;
                        let CREATE_DATE = checkInfo.find(item => item.REQUIRED_NAME.trim() === '创建日期') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '创建日期').ISREQUIRED : false;
                        let CASE_HISTORY = checkInfo.find(item => item.REQUIRED_NAME.trim() === '病史') ? checkInfo.find(item => item.REQUIRED_NAME.trim() === '病史').ISREQUIRED : false;
                        this.setState({
                              NAME_PHONETIC,
                              HEIGHT,
                              EXAM_AGE,
                              WEIGHT,
                              NATIVE_PLACE,
                              ZIP_CODE,
                              CONTACT_TEL,
                              ID_NUMBER,
                              MAILING_ADDRESS,
                              CREATE_DATE,
                              CASE_HISTORY,
                        })
                  }else{
				requestErrorLog('', '患者转诊-获取其他设置报错', 0,true)
                  }
            })
      }

      allBasicData = () => { //初始化基础数据
            getTypicalCasesBaseInfo().then((res) => {
                  if (res && res.Status === 1) {
                        const basicsdata = res.Result.basicsdata
                        Object.values(basicsdata).forEach((item) => {
                              if (item.name === "性别") {
                                    this.setState({
                                          sexType: item
                                    })
                              }
                        })
                  }else{
				requestErrorLog('', '患者转诊-获取性别报错', 0,true)
                  }
            });
      };

      initHospitalDept() { //申请科室
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            let Param = {
                  Type: "Hospital_Dept", //申请科室
                  hospital_Code: userInfo.HOSPITAL_CODE,
            };
            initHospitalDepts(Param).then((res) => {
                  if (res && res.Status === 1) {
                        this.setState({
                              departmentList: res.Result
                        })
                  }else{
				requestErrorLog('', '患者转诊-获取申请科室报错', 0,true)
                  }
            });
      }

      initDoctor = (code) => { //申请医生
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            let Param = {
                  Type: "Dept_Doctor", //申请医生
                  hospital_Code: userInfo.HOSPITAL_CODE,
                  Dept_Code: code
            }
            initDeptDoctor(Param).then((res) => {
                  if (res.Status === 1) {
                        const doctor = res.Result
                        this.setState({
                              doctorList: doctor
                        })
                  }else{
				requestErrorLog('', '患者转诊-获取申请医生报错', 0,true)
                  }
            });
      }

      handleHospitalDept = (value, option) => { //选择申请科室
            this.initDoctor(option.props.value)
            this.setState({
                  deptCode: option.props.value,
                  deptName: option.props.children,
            })
            this.props.form.setFieldsValue({
                  REQ_DOCTOR_NAME: undefined,
            });
      }

      handleDoctorSelect = (item, option) => { // 申请医生
            this.setState({
                  doctorCode: option.props.value,
                  doctorName: option.props.children,
            })
      }

      disabledDate = (current) => { //选择日期大于当天
            return current < moment().subtract(1, 'day');
      }

      disabledDates(current) {//选择日期小于当天
            return current > moment().endOf("day");
      }

      handleSaveReferral = (value) => { //保存
            const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
            const { rowData, clickType } = this.props
            this.props.form.validateFields((err, values) => {
                  if (!err) {
                        let param = {
                              Type: clickType,
                              USER_UID: userInfo.USER_UID
                        }
                        let requestModal = {
                              ...values,
                              PATIENT_UID: "" || rowData.PATIENT_UID,//远程申请跳转带PATIENT_UID
                              REQ_HOSPITAL_NAME: userInfo.HOSPITAL_NAME,
                              REQ_HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
                              APPLY_REFERRAL_DATE: rowData.APPLY_REFERRAL_DATE, //申请转诊时间
                              REFERRAL_HOSPITAL_NAME: rowData.REFERRAL_HOSPITAL_NAME, //转诊医院name
                              REFERRAL_HOSPITAL_CODE: rowData.REFERRAL_HOSPITAL_CODE, //转诊医院code
                              REQ_DEPT_NAME: this.state.deptName || values.REQ_DEPT_NAME,
                              REQ_DEPT_CODE: this.state.deptCode || values.REQ_DEPT_CODE,
                              REQ_DOCTOR_NAME: this.state.doctorName || values.REQ_DOCTOR_NAME,
                              REQ_DOCTOR_CODE: this.state.doctorCode || values.REQ_DOCTOR_CODE,
                              HEIGHT: values.HEIGHT || 0,
                              EXAM_AGE: values.EXAM_AGE || 0,
                              WEIGHT: values.WEIGHT || 0,
                              BIRTHDAY: moment(values.BIRTHDAY).format('YYYY-MM-DD'),
                              CREATE_DATE: moment(values.CREATE_DATE).format('YYYY-MM-DD'),
                              EXPECT_REFERRAL_DATE: moment(values.EXPECT_REFERRAL_DATE).format('YYYY-MM-DD'),

                        }
                        getNewReferral(param, requestModal).then((res) => {
                              if (res && res.Status === 1) {
                                    message.success("保存成功")
                                    this.props.onRef(false);
                                    if (value === 'saveReferral') {
                                          let applyReferralData = [{
                                                NAME: values.NAME,
                                                SEX_NAME: values.SEX === "U" ? "未知" : values.SEX === "M" ? "男" : values.SEX === "F" ? "女" : "未说明",
                                                REFERRAL_UID: rowData.REFERRAL_UID || res.Result.REFERRAL_UID
                                          }]
                                          this.props.onRef({
                                                applyVisible: true,
                                                applyReferralData
                                          })
                                    }
                                    this.props.refreshTable()
                              } else {
                                    requestErrorLog('', '患者转诊-保存患者报错', 0,true)
                                    message.error("保存失败")
                              }
                        })
                  }
            })
      }

      handleOutEdit = () => {
            this.props.onRef({
                  isModalVisible: false
            });
      }

      render() {
            const { sexType, departmentList, doctorList } = this.state
            const { visible, form: { getFieldDecorator }, clickType, rowData } = this.props
            return (
                  <>
                        <Modal
                              className="addPatientWrap"
                              width={1200}
                              title={
                                    <div className="patient_title">
                                          <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                                          <span>{clickType === "Add" ? "新建转诊申请" : "患者信息查看"}</span>
                                    </div>
                              }
                              visible={visible}
                              maskClosable={false}
                              onCancel={this.handleOutEdit}  // 右上角的关闭按钮
                              footer={
                                    clickType === "See" ? null :
                                          rowData.REFERRAL_STATUS_NAME === '已转诊' ? null :
                                                <div>
                                                      <Button key="save" type="primary" onClick={() => this.handleSaveReferral('save')}>
                                                            保存
                                                      </Button>
                                                      {
                                                            rowData.REFERRAL_STATUS_NAME === '转诊中' ? null :
                                                                  <Button key="referral" type="primary" onClick={() => this.handleSaveReferral('saveReferral')}>
                                                                        保存并转诊
                                                                  </Button>
                                                      }
                                                      <Button key="exit" type="primary" onClick={this.handleOutEdit}>
                                                            退出
                                                      </Button>
                                                </div>
                              }
                        >
                              <div className="add_wrap">
                                    <Form layout="inline" ref={this.formRef}>
                                          <Form.Item label="姓名">
                                                {getFieldDecorator('NAME', { rules: [{ required: true, message: '请输入姓名！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },], initialValue: rowData.NAME })(<Input onChange={(e) => handleEnglishName(e, this.props.form)} />)}
                                          </Form.Item>

                                          <Form.Item label="英文姓名">
                                                {getFieldDecorator('NAME_PHONETIC', { initialValue: rowData.NAME_PHONETIC, rules: [{ required: this.state.NAME_PHONETIC, message: '请输入英文姓名！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="性别">
                                                {getFieldDecorator('SEX', { rules: [{ required: true, message: '请选择性别！' }], initialValue: rowData.SEX })(
                                                      <Select placeholder="请选择性别">
                                                            {sexType && sexType.dt.map(item => (
                                                                  <Option value={item.DIC_CODE} key={item.DIC_CODE}>{item.DIC_NAME}</Option>
                                                            ))}
                                                      </Select>
                                                )}
                                          </Form.Item>

                                          <Form.Item label="身高(cm)">
                                                {getFieldDecorator('HEIGHT', { initialValue: rowData.HEIGHT, rules: [{ required: this.state.HEIGHT, message: '请输入身高！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="转诊编号">
                                                {getFieldDecorator('REFERRAL_UID', { initialValue: rowData.REFERRAL_UID, rules: [{ required: false, message: '请输入转诊编号！' }] })(<Input disabled />)}
                                          </Form.Item>

                                          <Form.Item label="年龄">
                                                {getFieldDecorator('EXAM_AGE', { initialValue: rowData.EXAM_AGE, rules: [{ required: this.state.EXAM_AGE, message: '请输入年龄！' }, { message: '年龄不能超过150且必须为整数！', pattern: /^[1][0-4][0-9]$|^[1-9]?[0-9]$|150/ }] })(
                                                      <Input min={1} max={150} onChange={(e) => changeAge(e, this.props.form)} addonAfter=
                                                            {getFieldDecorator('AGE_UNIT', { initialValue: clickType === "Add" ? "岁" : rowData.AGE_UNIT })(
                                                                  <Select className="select-after" onChange={(value) => handleChangeAgeUnit(value, this.props.form)}>
                                                                        <Option value="岁">岁</Option>
                                                                        <Option value="月">月</Option>
                                                                        <Option value="天">天</Option>
                                                                  </Select>
                                                            )} />
                                                )}
                                          </Form.Item >

                                          <Form.Item label="出生日期">
                                                {getFieldDecorator('BIRTHDAY', { rules: [{ required: true, message: '请选择出生日期！' }], initialValue: moment(rowData.BIRTHDAY) })(
                                                      <DatePicker allowClear={false} onChange={(date, dateString) => onChangeBirthday(date, dateString, this.props.form)} disabledDate={this.disabledDates} />
                                                )}
                                          </Form.Item>

                                          <Form.Item label="体重(kg)">
                                                {getFieldDecorator('WEIGHT', { initialValue: rowData.WEIGHT, rules: [{ required: this.state.WEIGHT, message: '请输入体重！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="籍贯">
                                                {getFieldDecorator('NATIVE_PLACE', { initialValue: rowData.NATIVE_PLACE, rules: [{ required: this.state.NATIVE_PLACE, message: '请输入籍贯！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="邮编">
                                                {getFieldDecorator('ZIP_CODE', { initialValue: rowData.ZIP_CODE, rules: [{ required: this.state.ZIP_CODE, message: '请输入邮编！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="手机号">
                                                {getFieldDecorator('CONTACT_TEL', { initialValue: rowData.CONTACT_TEL, rules: [{ required: this.state.CONTACT_TEL, message: '请输入手机号！' }, { message: '请输入正确的手机号！', pattern: /^[0-9]*$/ }] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="身份证号">
                                                {getFieldDecorator('ID_NUMBER', { initialValue: rowData.ID_NUMBER, rules: [{ required: this.state.ID_NUMBER, message: '请输入身份证号！' }, { message: '请输入正确的身份证号！', pattern: /^[\u9FA5a-zA-Z0-9_]{18}$/ }] })(<Input />)}
                                          </Form.Item>

                                          <Form.Item label="通讯地址" className="row">
                                                {getFieldDecorator('MAILING_ADDRESS', { initialValue: rowData.MAILING_ADDRESS, rules: [{ required: this.state.MAILING_ADDRESS, message: '请输入通讯地址！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(
                                                      <Input className="rowLine" />
                                                )}
                                          </Form.Item>


                                          <Form.Item label="申请科室">
                                                {getFieldDecorator('REQ_DEPT_NAME', {
                                                      rules: [{ required: true, message: '请选择申请科室！' }],
                                                      initialValue: rowData.REQ_DEPT_NAME,
                                                })(
                                                      <Select onSelect={this.handleHospitalDept} placeholder="请选择申请科室">
                                                            {departmentList.map((item) => (
                                                                  <Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
                                                                        {item.DEPT_NAME}
                                                                  </Option>
                                                            ))}
                                                      </Select>
                                                )}
                                          </Form.Item>

                                          <Form.Item label="申请医生">
                                                {getFieldDecorator('REQ_DOCTOR_NAME', { initialValue: rowData.REQ_DOCTOR_NAME, rules: [{ required: true, message: '请选择申请医生！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(
                                                      <Select onSelect={this.handleDoctorSelect} placeholder="请选择申请医生">
                                                            {doctorList.map(item => (
                                                                  <Option value={item.LOGIN_CODE} key={item.LOGIN_CODE}>{item.REAL_NAME}</Option>
                                                            ))}
                                                      </Select>
                                                )}
                                          </Form.Item>

                                          <Form.Item label="创建日期">
                                                {getFieldDecorator('CREATE_DATE', { initialValue: moment(rowData.CREATE_DATE), rules: [{ required: false, message: '请输入创建日期！' }] })(<DatePicker allowClear={false} disabled disabledDate={this.disabledDate} />)}
                                          </Form.Item>

                                          <Form.Item label="病史" className="row">
                                                {getFieldDecorator('CASE_HISTORY', { initialValue: rowData.CASE_HISTORY, rules: [{ required: this.state.CASE_HISTORY, pattern: /^[^\s]*$/, message: '请输入病史！' }] })(
                                                      <TextArea rows={6} />
                                                )}
                                          </Form.Item>

                                          <Form.Item label="转诊原由" className="row">
                                                {getFieldDecorator('REFERRAL_REASON', { initialValue: rowData.REFERRAL_REASON, rules: [{ required: true, message: '请输入转诊原由！' }, { pattern: /^[^\s]*$/, message: '禁止输入空格', },] })(
                                                      <TextArea rows={6} />
                                                )}
                                          </Form.Item>

                                          <div className="rightTime">
                                                <Form.Item label="预计转诊时间" >
                                                      {getFieldDecorator('EXPECT_REFERRAL_DATE', { rules: [{ required: true, message: '请选择预计转诊时间！' }], initialValue: rowData.EXPECT_REFERRAL_DATE ? moment(rowData.EXPECT_REFERRAL_DATE) : undefined })(
                                                            <DatePicker allowClear={false} disabledDate={this.disabledDate} format={'YYYY-MM-DD'} />
                                                      )}
                                                </Form.Item>
                                          </div>
                                    </Form>
                              </div>
                        </Modal>
                  </>
            )
      }
}


export default Form.create()(ReferralPatient);